import { Store } from '../../redux/store/store';

const VIRTUP_SHELL_UPGRADE_KEY = '__virtupUpgradedFromShell';

const DARK_GUEST_HOME_PATHS = new Set([
  '/home',
  '/home/client',
  '/home/consultant',
  '/home/marketing',
  '/home/career',
  '/home/itconsultant',
  '/client-home',
  '/consultant-home',
  '/career-home',
  '/marketing-home',
  '/it-home',
  '/login',
  '/signup',
]);

const DARK_GUEST_HOME_PREFIXES = [
  '/home/consultant/',
  '/home/marketing/',
  '/home/career/',
  '/home/itconsultant/',
];

const normalizePath = (pathname: string): string => {
  const path = (pathname || '/').split('?')[0] || '/';
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
};

export function markUpgradedFromShell(): void {
  if (typeof window !== 'undefined') {
    (window as Window & { [VIRTUP_SHELL_UPGRADE_KEY]?: boolean })[VIRTUP_SHELL_UPGRADE_KEY] = true;
  }
}

export function wasUpgradedFromShell(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!(window as Window & { [VIRTUP_SHELL_UPGRADE_KEY]?: boolean })[VIRTUP_SHELL_UPGRADE_KEY];
}

/** Match App.tsx body theme logic — apply before full-app mount to avoid body flash. */
export function getBodyClassForPath(pathname: string): string {
  const normalizedPath = normalizePath(pathname);
  const state = Store.getState();
  const loginData = state.userDataSlice?.loginData;
  const theme = state.UserIdentity?.[0]?.theme || 'light';

  if (normalizedPath === '/home') {
    return 'consultant-dark';
  }

  if (!loginData?.accessToken) {
    if (
      DARK_GUEST_HOME_PATHS.has(normalizedPath) ||
      DARK_GUEST_HOME_PREFIXES.some(
        (prefix) => normalizedPath === prefix.slice(0, -1) || normalizedPath.startsWith(prefix)
      )
    ) {
      return 'consultant-dark';
    }
    return 'client-light';
  }

  return theme === 'dark' ? 'consultant-dark' : 'client-light';
}

export function applyBodyClassForPath(pathname: string): void {
  if (typeof document === 'undefined') {
    return;
  }

  const bodyClass = getBodyClassForPath(pathname);
  document.body.classList.remove('client-light', 'consultant-dark');
  document.body.classList.add(bodyClass);
}
